<template>
  <div>
    <form v-if="isLogin" v-on:submit.prevent="login" class="forms">
      <div
        v-if="userFormErrors.non_field_errors.length"
        class="form-control is-error">
        <p
          v-for="(error, index) in userFormErrors.non_field_errors"
          :key="index"
          class="form-label is-error is-center-aligned">{{ error }}</p>
      </div>

      <VqInput
        class="mb-10"
        :label="$t('views.login.form.username')"
        name="username"
        type="text"
        :errors="userFormErrors.username"
        v-model="userForm.username"
      />

      <VqInput
        :label="$t('views.login.form.password')"
        name="password"
        type="password"
        :errors="userFormErrors.password"
        v-model="userForm.password"
      />


      <div class="form-control is-right-aligned">
        <router-link :to="{name: 'forgottenPassword', params: { locale: $i18n.locale }}">{{ $t('views.login.form.forget') }}</router-link>
      </div>

      <div class="form-control">
        <button
        :class="{'is-loading': isFormLoading}"
        class="button is-gamma">{{ $t('views.login.form.cta') }}</button>
      </div>
    </form>
    <div v-else class="forms">
      <VqInput
        :label="$t('views.login.form.code')"
        name="code"
        type="text"
        :errors="codeError.code"
        v-model="code"
      />

      <p class="pointer" @click="sendMfa()">{{ $t('views.login.form.send_again') }}</p>
      <button
        class="button is-gamma"
        @click="checkMfa()">{{ $t('views.login.form.cta') }}</button>
    </div>
  </div>

</template>

<script>
import { eventHubMixin } from '@/mixins/event';

import PROBLEMS from '@/api/problems';
import SUPPORT from '@/api/support';
import DIRECTOR from '@/api/director';
import AUTH from '@/api/auth';

import VqInput from '@/components/VqInput.vue';

export default {
  name: 'login',
  mixins: [eventHubMixin],
  components: {
    VqInput,
  },
  data: () => ({
    userForm: {
      username: '',
      password: '',
    },
    userFormErrors: {},
    code: "",
    codeError: "",
    isFormLoading: false,
    isLogin: true
  }),
  computed: {

  },

  created() {
    this.initFormErrors();
  },

  methods: {

    initFormErrors() {
      this.userFormErrors = {
        username: [],
        password: [],
        non_field_errors: [],
      };
    },

    login() {
      this.initFormErrors();
      this.isFormLoading = true;
      this.$store.dispatch('auth/login', this.userForm).then(() => {
        this.isFormLoading = false;
        SUPPORT.login(this.userForm);
        PROBLEMS.login(this.userForm);
        DIRECTOR.login(this.userForm);
        this.isLogin = false
      }, (err) => {
        this.isFormLoading = false;
        Object.assign(this.userFormErrors, err.response.data);
      });
    },

    checkMfa() {
      AUTH.checkMfa({code: this.code}).then(() => {
        this.$router.replace({ name: 'dashboard', params: { locale: this.$i18n.locale } });
      }, (err) => {
        this.codeError = err.response.data;
      });
    },

    sendMfa () {
      AUTH.sendMfa().then(() => {
        this.emitAddToaster({
          title: this.$t('views.login.form.code_sent'),
          text: this.$t('views.login.form.code_sent_detail'),
          state: 'success',
        })
      })
    }


  },
};
</script>
